module.exports = __webpack_public_path__ + "static/img/lives.92826a41.gif";